export default {"src":"/frontend-static/_next/static/media/ic_art.b28c2af2.svg","height":32,"width":25,"blurWidth":0,"blurHeight":0};